/**
 * Derive "am I getting alerts for this?" from the current user's subscription
 * keys ("group:<id>" / "team:<id>").
 *
 * A group subscription covers every team in the group, including teams created
 * later, so a team counts as watched when either its own key or its parent
 * group's key is present. A group also reads as watched when the user holds a
 * subscription on every one of its teams: older builds fanned a group
 * subscribe out into per-team rows, and those users should still see the
 * group as "Alerts On".
 */
export const groupKey = (groupId: string) => `group:${groupId}`;
export const teamKey = (teamId: string) => `team:${teamId}`;

export const isWatchingTeam = (
    subscriptions: Set<string>,
    teamId: string | null | undefined,
    groupId?: string | null
): boolean => {
    if (!teamId) return false;
    if (subscriptions.has(teamKey(teamId))) return true;
    return !!groupId && subscriptions.has(groupKey(groupId));
};

export const isWatchingGroup = (
    subscriptions: Set<string>,
    groupId: string | null | undefined,
    teamIds: ReadonlyArray<string>
): boolean => {
    if (!groupId) return false;
    if (subscriptions.has(groupKey(groupId))) return true;
    return teamIds.length > 0 && teamIds.every((tid) => subscriptions.has(teamKey(tid)));
};
